import axios from 'axios'
import axiosInstance from '../axiosInstance'
import { Url } from './constantUrl'
import * as types from './types'
import { errorHandler } from './error/errorHandler.action'
import { NotificationManager } from 'react-notifications'
import { HTTP_STATUS } from '../constants/httpstatus/HttpsStatus'
import { HTTP_METHOD } from '../constants/httpMethod/HttpMethod'


//Forgot Password Post API
export const forgotPasswordAction = (params = {}) => dispatch => {
    const API_URL = localStorage.getItem('countryBackendUrl')
    const url = API_URL + Url.FORGET_PASSWORD
    const options = {
      method: HTTP_METHOD.POST,
      url,
      ...(params && { data: params })
    };
    return axiosInstance(options).then(response => {
      if (response?.status === HTTP_STATUS.SUCCESS) {
        dispatch({ type: types.POST_FORGET_PASSWORD, payload: response })
        return response
      } else { return null }
    }).catch(error => {
      if (error?.response?.status === HTTP_STATUS.ERROR) {
        const errorMessage = error.response?.data?.data?.error || error?.response?.data?.data?.language_id;
        if(errorMessage){
          NotificationManager.error(errorMessage);
        }else{
          errorHandler(error)
        }
    }
    })
  }

//Reset Password Post API
export const resetPasswordAction = (params = {}) => dispatch => {
    const API_URL = localStorage.getItem('countryBackendUrl')
    const url = API_URL + Url.RESET_PASSWORD
    const options = {
      method: HTTP_METHOD.POST,
      url,
      ...(params && { data: params })
    };
    return axiosInstance(options).then(response => {
      if (response.status === HTTP_STATUS.SUCCESS) {
        dispatch({ type: types.POST_RESET_PASSWORD, payload: response })
        return response
      } else { return null }
    }).catch(error => {
      if (error?.response?.status === HTTP_STATUS.ERROR) {
        const errorMessage = error?.response?.data?.data?.new_password || error?.response?.data?.data?.error;
        if(errorMessage){
          NotificationManager.error(errorMessage);
        }else{
          errorHandler(error)
        }
    }
    })
  }